export default __webpack_public_path__ + "static/media/Portugal2020.633b55e2.svg";